export const poiTypes = [
  {
    id: 11,
    name: "Ulaşım",
  },
  {
    id: 2,
    name: "Okullar",
  },
  {
    id: 8,
    name: "Sağlık Kurumları",
  },
  {
    id: 5,
    name: "Kafe/Restoranlar",
  },
  {
    id: 7,
    name: "Marketler",
  },
];
